import React, { useContext, useState } from 'react';
import { SxProp, View, Image } from 'dripsy';

import { UniSkeleton } from './UniSkeleton';
import { TextBody, TextCaption } from '@/design-system/components/typography';
import { Icon } from '../icons/Icon';
import { CurrenciesContext } from '../../../currencies/currency.context';

interface AssetCardDefaultProps {
  asset: string;
  subText?: string;
  loading?: false;
}

interface AssetCardLoadingProps {
  loading: true;
}

export type AssetCardProps = AssetCardDefaultProps | AssetCardLoadingProps;

export const UniAssetCard: React.FC<AssetCardProps> = (props) => {
  if ('loading' in props && props.loading === true) {
    return <UniAssetCardLoading />;
  }

  const [error, setError] = useState<boolean>(false);

  const { asset, subText } = props;
  const { currenciesDict } = useContext(CurrenciesContext);

  const uri = currenciesDict?.[asset]?.token_image_url;

  return (
    <View sx={sxStyles.container}>
      <View sx={sxStyles.containerLeft}>
        <View
          sx={{
            borderRadius: 100,
            borderWidth: 1,
            borderColor: '$borderPrimary'
          }}>
          {(!uri || error) && <Icon name={asset.toLowerCase()} height={30} width={30} />}
          {uri && !error && (
            <Image
              source={{
                uri
              }}
              sx={{ height: 30, width: 30 }}
              onError={() => setError(true)}
            />
          )}
        </View>
      </View>
      <View sx={sxStyles.containerRight}>
        <TextBody semiBold label>
          {asset}
        </TextBody>
        {subText && <TextCaption secondary>{subText}</TextCaption>}
      </View>
    </View>
  );
};

const UniAssetCardLoading: React.FC<any> = () => (
  <View sx={sxStyles.container}>
    <View sx={sxStyles.containerLeft}>
      <UniSkeleton shape="round" style={{ height: 30, width: 30 }} />
    </View>
    <View sx={sxStyles.containerRight}>
      <UniSkeleton style={{ marginBottom: 4, height: 15, width: 80 }} />
      <UniSkeleton style={{ height: 17, width: 120 }} />
    </View>
  </View>
);

const sxStyles: Record<string, SxProp> = {
  container: {
    flexDirection: 'row',
    alignItems: 'center'
  },
  containerLeft: {
    justifyContent: 'center',
    alignItems: 'center'
  },
  containerRight: {
    marginLeft: 12,
    flexDirection: 'column',
    gap: 4
  }
};
